import { money, formatDate } from "@/lib/format";
import type { TimelineEntry } from "@/lib/metrics";
import Icon3D, { type Icon3DTone } from "@/components/base/Icon3D";

const kindStyle: Record<
  TimelineEntry["kind"],
  { icon: string; cls: string; label: string; tone: Icon3DTone }
> = {
  purchase: { icon: "ri-shopping-cart-2-line", cls: "bg-secondary-100 text-secondary-700", label: "Compra", tone: "secondary" },
  sale: { icon: "ri-shopping-bag-3-line", cls: "bg-primary-100 text-primary-700", label: "Venta", tone: "primary" },
  expense: { icon: "ri-wallet-3-line", cls: "bg-background-200 text-foreground-600", label: "Gasto", tone: "neutral" },
  return: { icon: "ri-arrow-go-back-line", cls: "bg-accent-100 text-accent-800", label: "Devolución", tone: "accent" },
};

interface Props {
  entry: TimelineEntry;
  onClick?: () => void;
  onDelete?: () => void;
}

export default function MovementRow({ entry, onClick, onDelete }: Props) {
  const style = kindStyle[entry.kind];
  const sign = entry.positive ? "+" : "-";
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-3 px-4 py-3 ${onClick ? "cursor-pointer active:bg-background-100" : ""}`}
    >
      <span className={`flex h-10 w-10 flex-none items-center justify-center rounded-2xl ${style.cls}`}>
        <Icon3D icon={style.icon} tone={style.tone} size={22} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-[14px] font-medium text-foreground-900">{entry.title}</p>
        <p className="truncate text-[12px] text-foreground-500">
          {formatDate(entry.date)} · {entry.subtitle}
        </p>
      </div>
      <div className="text-right">
        <p
          className={`tabular-nums text-[14px] font-semibold ${
            entry.positive ? "text-primary-700" : "text-foreground-800"
          }`}
        >
          {sign}
          {money(entry.amount, entry.currency)}
        </p>
        <p className="text-[10px] text-foreground-400">{style.label}</p>
      </div>
      {onDelete ? (
        <button
          type="button"
          aria-label="Eliminar movimiento"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="flex h-8 w-8 flex-none items-center justify-center rounded-full text-foreground-400 active:bg-red-50 active:text-red-500"
        >
          <i className="ri-delete-bin-line text-[17px]" />
        </button>
      ) : null}
    </div>
  );
}